import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChartAccountsCategoryEnum } from 'taxtank-core';

@Component({
  selector: 'app-chart-accounts-manage-dialog',
  templateUrl: './chart-accounts-manage-dialog.component.html',
  styleUrls: ['./chart-accounts-manage-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChartAccountsManageDialogComponent implements OnInit {
  public category = inject<ChartAccountsCategoryEnum>(MAT_DIALOG_DATA);

  categoryLabel = 'Personal';
  

  ngOnInit(): void {
    if (this.category) {
      this.categoryLabel = 'Depreciation';
    }
  }
}
